import { addMonths } from "date-fns";

export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";

const initialState = {
  dashboardStartDate: addMonths(new Date(), -6),
  dashboardEndDate: new Date(),
  isDashboardLoading: false,
  roiSummaries: [],
  resetBtn: true,
  // Customer Renewals Analysis state
  isCustomerRenewalsLoading: false,
  customerRenewalsData: null,
  customerRenewalsError: null,
  customerRenewalsStartDate: addMonths(new Date(), -6),
  customerRenewalsEndDate: new Date(),
  customerRenewalsPartnerName: null,
  customerRenewalsUsePrimarySite: false,
  customerRenewalsDistributerList: [],
  customerRenewalsMultiSelectedDistributersKey: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DASHBOARD_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
